import { Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { osirisTokens } from '@/theme/tokens';

interface CheckboxCellProps {
  checked: boolean;
  size?: number;
}

/** Figma checkbox square: section-header fill when off, accent + check when on. */
export function CheckboxCell({ checked, size = 24 }: CheckboxCellProps) {
  return (
    <Box
      className={`checkbox-cell${checked ? ' is-checked' : ''}`}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '1px',
        bgcolor: checked ? osirisTokens.accent.main : osirisTokens.bg.header,
        transition: 'background-color 120ms ease',
      }}
    >
      {checked && <CheckIcon sx={{ fontSize: 16, color: '#fff' }} />}
    </Box>
  );
}

interface CheckboxChipProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

/**
 * Figma labeled checkbox chip (e.g. INVERT): 24px checkbox cell + mono caps
 * label cell, joined with a 1px gap.
 */
export function CheckboxChip({ label, checked, onChange, className }: CheckboxChipProps) {
  return (
    <Box
      className={`checkbox-chip${checked ? ' is-checked' : ''}${className ? ' ' + className : ''}`}
      onClick={() => onChange(!checked)}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 24,
        gap: '1px',
        cursor: 'pointer',
        userSelect: 'none',
      }}
    >
      <Box sx={{ '& .checkbox-cell': { borderRadius: '1px 0 0 1px' } }}>
        <CheckboxCell checked={checked} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 24,
          px: 1,
          borderRadius: '0 1px 1px 0',
          bgcolor: osirisTokens.bg.header,
          fontFamily: osirisTokens.fonts.mono,
          fontSize: 12,
          letterSpacing: '0.02em',
          textTransform: 'uppercase',
          color: checked ? osirisTokens.icons.primary : osirisTokens.icons.tertiary,
        }}
      >
        {label}
      </Box>
    </Box>
  );
}
